import { Tabs, useTheme } from '@mui/material'

/**
 * Styled Tabs wrapper with TerraPlan dense tab styling:
 * - Compact 20px tab height
 * - Passive indicator line under every tab (divider color)
 * - Active indicator (primary.dark / primary.light in dark mode)
 * - Selected tab background tint (primary[100] / primary[400] in dark mode)
 *
 * Drop-in replacement for MUI <Tabs> — all props forwarded.
 */
export const TpTabs = ({ sx, ...props }) => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <Tabs
      sx={{
        minHeight: 'unset',
        '& .MuiTab-root': {
          minHeight: 20,
          padding: '4px 12px',
          position: 'relative',
          transition: 'background-color 150ms ease',
          '&.Mui-selected': {
            backgroundColor: isDark ? theme.palette.primary[400] : theme.palette.primary[100],
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: theme.palette.divider,
          },
        },
        '& .MuiTabs-indicator': {
          height: '2px',
          backgroundColor: isDark ? theme.palette.primary.light : theme.palette.primary.dark,
          zIndex: 1,
        },
        ...sx,
      }}
      {...props}
    />
  )
}
